export const PUBLIC_ROUTES = {
    ROOT: '/',
    TEAM: {
        PATH: 'team',
        FULL: '/team',
    },
    PARTNERS: {
        PATH: 'partners-page',
        FULL: '/partners-page',
    },
    ABOUT_US: {
        PATH: 'about-us',
        FULL: '/about-us',
    },
    PROGRAMS: {
        PATH: 'programs',
        FULL: '/programs',
    },
    DONATE: {
        PATH: 'donate',
        FULL: '/donate',
    },
    MOCK: {
        PATH: 'about-us',
        FULL: '/about-us',
    },
};
